// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTileBackSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';
import Footer from './Izenda.ReportPartTileBackSideFooter';
import TileTitleBackSide from '../Izenda.TileTitleBackSide';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import DashboardFilterDescriptions from './Izenda.DashboardFilterDescriptions';
import ReportDesignerStore from 'logic/Izenda.ReportDesignerStore';
import ReportDesignerFieldsStore from 'logic/Izenda.ReportDesignerFieldsStore';
import reportDesignerConstants from 'logic/data/Izenda.ReportDesignerConstants';
import IntegrationStyleAction from 'pages/Izenda.IntegrationStyleAction';
import ReportViewerFilters from 'modules/Reports/ReportViewer/Izenda.ReportViewerFilters';
import { map, isEmpty, get } from 'lodash/fp';

const integrationStyleAction = IntegrationStyleAction.checkDisplayByKey('hideDashboardPartFilter');
const ReportFilter = integrationStyleAction(ReportViewerFilters);

@observer
class ReportPartFilter extends Component {
  static displayName = 'ReportPartFilter';

  constructor(props) {
    super(props);

    this.masterStore = new ReportDesignerStore(true, props.dashboardPart.reportId);
    this.reportDesignerFieldsStore = new ReportDesignerFieldsStore(
      this.masterStore,
      true,
      reportDesignerConstants.REPORT_STATE.SAVED
    );
    this.masterStore.fieldsStore.masterModel.read(props.dashboardPart.report);
    let configFields = map(item => item.configField, props.dashboardPart.filters);
    this.reportDesignerFieldsStore.model.reportFilter.populateFilterList(map(item => item.fieldDetails, configFields));
    this.reportDesignerFieldsStore.model.reportFilter.configFieldList = configFields;

    this.originalGetData = this.reportDesignerFieldsStore.getData;
    this.reportDesignerFieldsStore.getData = this.customGetData();
  }

  customGetData = () => {
    let reportDesignerFieldsStore = this.reportDesignerFieldsStore;
    let originalGetData = this.originalGetData;
    return (pageInfo, configField, searchKey, isSearching) => {
      return originalGetData.call(reportDesignerFieldsStore, pageInfo, configField, searchKey, isSearching, true);
    };
  };

  render() {
    let { dashboardPart, accessPriority, dashboardPart: { filters, individualConfigFieldList } } = this.props;

    const operatorSource = get('store.dashboardFilterStore.model.reportFilter.displayConfigFields', this.props);

    if (isEmpty(filters)) {
      return null;
    }
    return (
      <GridLayout.Row className="u_noMarginRight u_noMarginLeft">
        <GridLayout.Col>
          <ReportFilter
            haveFreeze={false}
            configFields={individualConfigFieldList}
            isLazyLoading
            fieldStore={this.reportDesignerFieldsStore}
            accessPriority={accessPriority}
          >
            <DashboardFilterDescriptions dashboardPart={dashboardPart} operatorSource={operatorSource} />
          </ReportFilter>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }
}

const ReportPartTileBackSide = props => {
  return (
    <GridLayout className="report-part-back-side u_fullSize u_table">
      <GridLayout.Row className="u_tableRow u_fullHeight">
        <GridLayout.Col className="u_overflowAuto u_fullHeight">
          <ScrollBox>
            <GridLayout className="u_paddingTop u_paddingBottom">
              <ReportPartFilter {...props} />
              <GridLayout.Row className="u_noMarginRight u_noMarginLeft">
                <GridLayout.Col>
                  <TileTitleBackSide dashboardPart={props.dashboardPart} />
                </GridLayout.Col>
              </GridLayout.Row>
            </GridLayout>
          </ScrollBox>
        </GridLayout.Col>
      </GridLayout.Row>
      <GridLayout.Row className="u_tableRow report-part-footer">
        <GridLayout.Col className="u_controlHeight u_marginTop u_marginBottom">
          <Footer dashboardPart={props.dashboardPart} store={props.store} />
        </GridLayout.Col>
      </GridLayout.Row>
    </GridLayout>
  );
};

ReportPartTileBackSide.propTypes = {
  dashboardPart: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired
};

ReportPartTileBackSide.displayName = 'ReportPartTileBackSide';

export default observer(ReportPartTileBackSide);



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/ReportPartTile/Izenda.ReportPartTileBackSide.js